//noinspection BadExpressionStatementJS,UnterminatedStatementJS
define({ root:

    ({
        ok: "OK",
        cancel: "Cancel",
        switchPanes: "Switch Windows",
        close: "Close",
        yes: "Yes",
        no: "No"
    }),

    "ja-jp": true,
    "ko-kr": true,
    "zh-cn": true
});
